import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=72d25d8b&scoped=true"
import script from "./LayoutForm.vue?vue&type=script&lang=js"
export * from "./LayoutForm.vue?vue&type=script&lang=js"
import style0 from "./LayoutForm.vue?vue&type=style&index=0&id=72d25d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d25d8b",
  null
  
)

export default component.exports